/* GriffinLayout.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3SamIHVa5s%7Bmargin-block%3Avar(--ds-space-400%2C2pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2Y7lL45zaO%7Bpadding-inline%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1mT5xdRAKS%7Bposition%3Arelative%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2xTnZxIZbP%7Bmargin-inline-end%3Aauto%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0GTcwRIZbP%7Bmargin-inline-start%3Aauto%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._24h04iPvdi%7Bbox-sizing%3Acontent-box%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1EqgXlprl1%7Bmax-width%3A77pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20(min-width%3A64rem)%7B._1DVCh3Va5s%7Bpadding-inline%3Avar(--ds-space-400%2C2pc)%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1EqgXlOAqP%7Bmax-width%3A50pc%7D");
import React, { ComponentType } from 'react';
import ExitingPersistence from '@atlaskit/motion/exiting-persistence';
import { Main } from '@atlaskit/navigation-system/layout/main';
import Box from '@atlaskit/primitives/box';
import { media } from '@atlaskit/primitives/responsive/media';
// eslint-disable-next-line @townsquare/rules/no-xcss
import { xcss } from '@atlaskit/primitives/xcss';
// eslint-disable-line @typescript-eslint/no-unused-vars

import { GriffinMainGrid } from '@townsquare/griffin-main-grid';
import { GriffinMainGridContent } from '@townsquare/griffin-main-grid/content';
import { GriffinMainGridHeader } from '@townsquare/griffin-main-grid/header';
import { PreviewPanelContainer } from '@townsquare/preview-panels/previewPanelContainer';
import { AggRelayEnvironmentProvider } from '@townsquare/relay-utils/agg-environment';
import { RouteComponent } from '@townsquare/router/RouteComponent';
import { HomepageRoute, LayoutType } from '@townsquare/router/route-types';
import { useRouter } from '@townsquare/router/useRouter';
import { RovoButton } from '@townsquare/rovo-ai-button';
import { useRightSidebarState } from '@townsquare/sidebar-panel/right-sidebar';
import { isEntryPointPanelSupported } from '@townsquare/sidebar-panel/utils';
import { LegacySidebarPanel } from '@townsquare/sidebar-panel-utils/legacy-sidebar-panel';
import { fg } from '@townsquare/stat-sig/gate';
import { GriffinResponsiveAside } from './GriffinResponsiveAside';
const AggRelayProvider = ({
  children
}: {
  children: React.ReactNode;
}) => <AggRelayEnvironmentProvider>{children}</AggRelayEnvironmentProvider>;

// Expected with for main column CONTENT is 1232px.
const MAIN_CONTENT_LX_WIDTH = '1232px';
type AsideType = Exclude<HomepageRoute['aside'], undefined>;
type GriffinLayoutProps = {
  aside: AsideType | undefined;
  layout: LayoutType;
};

/**
 * Additional default styling to conform to a grid structure
 */
const defaultMainContentStyles = xcss({
  position: 'relative',
  marginInlineEnd: 'auto',
  marginInlineStart: 'auto',
  // We want the column content width to be the set width, with padding and margin added on top.
  boxSizing: 'content-box',
  maxWidth: MAIN_CONTENT_LX_WIDTH,
  marginBlock: 'space.400',
  paddingInline: 'space.200',
  // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
  [media.above.md]: {
    paddingInline: 'space.400'
  }
});
const mainContentWithAsideStyles = xcss({
  // If there is an aside column, we don't want the max page width to exceed 800px.
  maxWidth: '800px'
});
const compiledMainContentStyles = {
  base: "_3SamIHVa5s _2Y7lL45zaO _1mT5xdRAKS _2xTnZxIZbP _0GTcwRIZbP _24h04iPvdi _1EqgXlprl1 _1DVCh3Va5s",
  withAside: "_1EqgXlOAqP"
};
const GriffinMainContent = (props: GriffinLayoutProps) => {
  const useDefaultStyle = props.layout === 'home';
  return <GriffinMainGridContent>
			{useDefaultStyle ? fg('townsquare-compiled-xcss-to-cssmap-final') ? <div className={ax([compiledMainContentStyles.base, props.aside && ""])}>
						<RouteComponent />
					</div> : <Box xcss={[defaultMainContentStyles, props.aside ? mainContentWithAsideStyles : undefined]}>
						<RouteComponent />
					</Box> : <RouteComponent />}
		</GriffinMainGridContent>;
};
const GriffinWithAside = (props: GriffinLayoutProps & {
  aside: AsideType;
  hasNewHeader: boolean;
}) => {
  const AsideComponent = props.aside;
  return <>
			<GriffinMainContent {...props} />
			<GriffinResponsiveAside hasNewHeader={props.hasNewHeader}>
				<AsideComponent />
			</GriffinResponsiveAside>
		</>;
};
export const GriffinLayout = ({
  PlatformSidebarPanel
}: {
  PlatformSidebarPanel: ComponentType;
}): React.JSX.Element => {
  const {
    currentPanel
  } = useRightSidebarState();
  const [routerState] = useRouter();
  const route = (routerState.route as HomepageRoute);
  const layout = route.nav4Layout ?? (route?.layout || 'home');
  const HeaderComponent = route.header;
  const AggContainer = route.aggContainer;
  const shouldShowSidebarPanel = currentPanel && isEntryPointPanelSupported(currentPanel);
  const content = route.aside ? <GriffinWithAside layout={layout} aside={route?.aside} hasNewHeader={!!route.header} /> : <GriffinMainContent layout={layout} aside={route?.aside} />;
  const entryPointSidebarPanel = shouldShowSidebarPanel ? <PlatformSidebarPanel key="entry-point-sidebar-panel" /> : null;

  // `ExitingPersistence` has to sit outside the conditional so the panel it is holding onto
  // survives `shouldShowSidebarPanel` flipping to false and can play its exit motion.
  const SidebarPanel = <>
			{fg('platform-dst-motion-uplift-panel') ? <ExitingPersistence>{entryPointSidebarPanel}</ExitingPersistence> : entryPointSidebarPanel}
			{!shouldShowSidebarPanel && <LegacySidebarPanel currentPanel={currentPanel} />}
		</>;
  const RelayProvider = route.relayEnvironment === 'agg' ? AggRelayProvider : React.Fragment;
  if (layout === 'custom') {
    return <RelayProvider>
				<Main testId={routerState.route.name}>
					<RouteComponent />
					<RovoButton />
				</Main>
				{SidebarPanel}
				{fg('townsquare_projects_preview_panel_enabled') && <PreviewPanelContainer />}
			</RelayProvider>;
  }
  const LayoutContent = <RelayProvider>
			<Main testId={routerState.route.name}>
				<GriffinMainGrid>
					{HeaderComponent && <GriffinMainGridHeader>
							<HeaderComponent />
						</GriffinMainGridHeader>}
					{content}
				</GriffinMainGrid>
				<RovoButton />
			</Main>
			{SidebarPanel}
			{fg('townsquare_projects_preview_panel_enabled') && <PreviewPanelContainer />}
		</RelayProvider>;
  if (fg('townsquare_enable_combined_agg_query_sidebar') && AggContainer) {
    return <AggContainer>{LayoutContent}</AggContainer>;
  }
  return LayoutContent;
};